import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5014/api/v1';
const AUTH_API = BASE.replace('/api/v1', '/api/auth');

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  // Restore session from localStorage on mount
  useEffect(() => {
    const storedToken = localStorage.getItem('knkt_ue_token');
    const storedUser = localStorage.getItem('knkt_ue_user');

    if (storedToken && storedUser) {
      // Validate token with backend
      axios.get(`${AUTH_API}/validate`, {
        headers: { Authorization: `Bearer ${storedToken}` }
      })
        .then(() => {
          setToken(storedToken);
          setUser(JSON.parse(storedUser));
        })
        .catch(() => {
          // Token expired or invalid — clear storage
          localStorage.removeItem('knkt_ue_token');
          localStorage.removeItem('knkt_ue_user');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const response = await axios.post(`${AUTH_API}/login`, { email, password });
    const { token: newToken, user: newUser } = response.data;

    localStorage.setItem('knkt_ue_token', newToken);
    localStorage.setItem('knkt_ue_user', JSON.stringify(newUser));

    setToken(newToken);
    setUser(newUser);
  };

  const logout = () => {
    localStorage.removeItem('knkt_ue_token');
    localStorage.removeItem('knkt_ue_user');
    setToken(null);
    setUser(null);
  };

  // Called after SSO sets localStorage externally
  const refreshFromStorage = () => {
    const t = localStorage.getItem('knkt_ue_token');
    const u = localStorage.getItem('knkt_ue_user');
    if (t && u) {
      try {
        setToken(t);
        setUser(JSON.parse(u));
      } catch {}
    }
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, loading, refreshFromStorage }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
